import { Box, Typography, Container, Paper, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { keyframes } from '@mui/system'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const tada = keyframes`
  0% {
    transform: scale(1);
  }
  10%, 20% {
    transform: scale(0.9) rotate(-3deg);
  }
  30%, 50%, 70%, 90% {
    transform: scale(1.1) rotate(3deg);
  }
  40%, 60%, 80% {
    transform: scale(1.1) rotate(-3deg);
  }
  100% {
    transform: scale(1) rotate(0);
  }
`

export default function WixInstallSuccess() {
  const navigate = useNavigate()

  return (
    <Container maxWidth='md'>
      <Box
        sx={{
          minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 8,
        }}
      >
        <Paper
          sx={{
            boxShadow: 4,
            p: 4,
            textAlign: 'center',
            maxWidth: 400,
            width: '100%',
            animation: `${fadeIn} 0.8s ease-out`,
          }}
        >
          <Typography
            variant='h2'
            component='h1'
            gutterBottom
            sx={{
              mb: 3,
              '& .emoji': {
                display: 'inline-block',
                animation: `${tada} 1s ease-in-out`,
                animationDelay: '0.5s',
              },
            }}
          >
            <span className='emoji'>🎉</span> Congratulations!
          </Typography>

          <Typography variant='h4' gutterBottom>
            Your Web Wisdom has been successfully installed on your Wix Website.
          </Typography>

          <Typography
            variant='body2'
            sx={{
              my: 3,
            }}
          >
            You can now customize your concierge&apos;s appearance and behavior
            from your dashboard.
          </Typography>

          <Button
            variant='contained'
            onClick={() => navigate('/web-concierge/customize')}
          >
            Customize Your Concierge
          </Button>
        </Paper>
      </Box>
    </Container>
  )
}
